import { useEffect, useRef } from 'react'
import { showCustomNotification } from '~/helperFunctions/customNotifications'
import { subscribeApiError } from '~/utils/apiErrorEvents'

import { useLocation } from '@remix-run/react'

export default function ApiErrorToast() {
  const shownRef = useRef<string | null>(null)
  const { key } = useLocation()

  useEffect(() => {
    shownRef.current = null
  }, [key])

  useEffect(() => {
    return subscribeApiError((message) => {
      if (!message || shownRef.current === message) {
        return
      }

      shownRef.current = message
      showCustomNotification({
        title: 'Error',
        message,
        color: 'red',
        autoClose: 8000,
      })
    })
  }, [])

  return null
}
